












import VueOptions from '@utils/VueOptions'
import WizardNavbar from '@ui/ShippingAreaWizard/WizardNavbar'
import WizardNavigation from '@ui/ShippingAreaWizard/WizardNavigation'
import ShippingAreaVenueBindSelector from '@ui/ResourceBindSelector/ShippingAreaVenueBindSelector'
import Modal from '@components/Modal'

settings =
  name: 'AvailabilityStep'

  vue:
    props: ['wizard', 'step']

    components: {
      WizardNavbar,
      WizardNavigation,
      ShippingAreaVenueBindSelector,
      Modal,
    }

    computed:
      optionsForBindSelector: ->
        supplierId: @wizard.supplierId

export default VueOptions.vue settings
